import { Component, input } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './app-footer.component.html',
  styleUrls: ['./app-footer.component.scss'],
  standalone: false,
})
export class AppFooterComponent {
  // Lets us know if we're in a public facing page (un-authenticated)
  public public = input<boolean>(false);

  // Determines if copyright text should display
  public copyright = input<boolean>(false);

  constructor() {}
}
